import ScrollAnimation from "react-animate-on-scroll";
import { Col, Collapse, Container, Row } from "react-bootstrap";
import icon4 from "../../../images/webdevelopment/cms.svg";
import icon1 from "../../../images/webdevelopment/Icon awesome-mobile-alt.svg";
import icon3 from "../../../images/digitaltrans/icons8-code-80.png";
import icon2 from "../../../images/digitaltrans/devices.png";
import plat1 from "../../../images/icons/flutter.png";
import plat2 from "../../../images/icons/native.png";
import plat3 from "../../../images/icons/react.png";
import plat4 from "../../../images/icons/android.png";
import plat5 from "../../../images/icons/kotlin.png";
import plat6 from "../../../images/icons/ios.png";
import plat7 from "../../../images/icons/ionic.png";
import plat8 from "../../../images/icons/xamarin.png";
import plat9 from "../../../images/icons/html.png";
import plat10 from "../../../images/icons/css.png";
import plat11 from "../../../images/icons/4-2.png";
import plat12 from "../../../images/icons/js.png";
import plat13 from "../../../images/icons/react.png";
import plat14 from "../../../images/icons/vue.png";
import plat15 from "../../../images/icons/typescript.png";
import plat16 from "../../../images/icons/mean.png";
import plat17 from "../../../images/icons/aws.png";
import plat18 from "../../../images/icons/hadoop.png";
import plat19 from "../../../images/icons/nodejs.png";
import plat20 from "../../../images/icons/python.png";
import plat21 from "../../../images/icons/java1.png";
import plat22 from "../../../images/icons/mysql.png";
import plat23 from "../../../images/icons/php.png";
import plat24 from "../../../images/icons/devops.png";
import plat25 from "../../../images/icons/wordpress.png";
import plat26 from "../../../images/icons/drupal.png";
import plat27 from "../../../images/icons/sharepoint.png";
import plat28 from "../../../images/icons/magento.png";
import plat29 from "../../../images/icons/shopify.png";
import plat30 from "../../../images/icons/wpcommerce.png";

import "react-multi-carousel/lib/styles.css";
import { AnimatedLine } from "../../common/designParts/animatedUnderline";
import { useViewport } from "../../common/designParts/useViewport";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const WebExpertise = () => {
  const { width } = useViewport();
  const breakpoint = 768;
  const [openExp, setOpenExp] = useState(false);
  const [openWeb, setOpenWeb] = useState(false);
  return (
    <Container className="mcontainerpadding ">
      <div id="expertise"></div>
      <Row>
        <Col md={12}>
          <ScrollAnimation
            animateIn="animate-text"
            duration={5}
            animateOnce={true}
          >
            <h2 className="h2heading1">
              Our Development{" "}
              <span className="bold">
                <span className="bold">Platforms & Frameworks Expertise</span>
              </span>
            </h2>
          </ScrollAnimation>
          <AnimatedLine
            className="animateline"
            width={"200px"}
            margin={"-5px 0"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>
        </Col>
      </Row>
      <br />

      <Row>
        <Col md={6} sm={6} xs={12} lg={6} xl={3}>
          <ScrollAnimation animateIn="fadeIn" duration={2} animateOnce={true}>
            <div class="numberCircle textcenter">
              <img alt="" src={icon1} className="platimage" />
            </div>
            <div
              className="card platcard digi-platforms"
              style={{ height: "auto" }}
            >
              <p className="devheading">
                <span className="bold">Mobile <br /> Development</span> 
                <AnimatedLine
            className="animateline"
            width={"200px"}
            margin={"10px auto"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>
              </p>
              
              <div class="mflex-container digi-ex-cont">
                <div>
                  <img alt="" src={plat1} className="platimgnew " />

                  <p className="platparagraph">Flutter</p>
                </div>
                <div>
                  <img alt="" src={plat2} className="platimgnew " />
                  <p className="platparagraph">Native Script</p>
                </div>
              </div>
              <div class="mflex-container digi-ex-cont">
                <div>
                  <img alt="" src={plat3} className="platimgnew" />

                  <p className="platparagraph">React Native</p>
                </div>
                <div>
                  <img alt="" src={plat4} className="platimgnew" />
                  <p className="platparagraph">Android</p>
                </div>
              </div>

              <Collapse in={width < breakpoint ? openExp === "first" : true}>
                <div id="first">
                  <div class="mflex-container">
                    <div>
                      <img alt="" src={plat5} className="platimgnew" />

                      <p className="platparagraph">Kotlin</p>
                    </div>
                    <div>
                      <img alt="" src={plat6} className="xcodeimg" />
                      <p className="platparagraph">iOS</p>
                    </div>
                  </div>
                  <div class="mflex-container">
                    <div>
                      <img alt="" src={plat7} className="platimgnew" />

                      <p className="platparagraph">Ionic</p>
                    </div>
                    <div>
                      <img alt="" src={plat8} className="xcodeimg" />
                      <p className="platparagraph">Xamarin</p>
                    </div>
                  </div>
                </div>
              </Collapse>
              <button className="d-xl-none d-lg-none d-md-none collapse-btn-services text-center mr-auto ml-auto pt-2">
                {openExp === "first" ? (
                  <FontAwesomeIcon
                    icon="chevron-up"
                    onClick={() => setOpenExp(false)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon="chevron-down"
                    onClick={() => setOpenExp("first")}
                    aria-controls="first"
                    aria-expanded="first"
                  />
                )}
              </button>
            </div>
          </ScrollAnimation>
        </Col>

        {/* section 2 */}
        <Col md={6} sm={6} xs={12} lg={6} xl={3}>
          <ScrollAnimation animateIn="fadeIn" duration={2} animateOnce={true}>
            <div class="numberCircle textcenter">
              <img alt="" src={icon2} className="platimage" />
            </div>
            <div
              className="card platcard digi-platforms"
              style={{ height: "auto" }}
            >
              <p className="devheading">
                <span className="bold">
                  {" "}
                  Front-End <br /> Development
                </span>
                <AnimatedLine
            className="animateline"
            width={"200px"}
            margin={"10px auto"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>
              </p>
              
              <div class="mflex-container digi-ex-cont">
                <div>
                  <img alt="" src={plat9} className="platimgnew " />

                  <p className="platparagraph">HTML5</p>
                </div>
                <div>
                  <img alt="" src={plat10} className="platimgnew " />
                  <p className="platparagraph">CSS3</p>
                </div>
              </div>
              <div class="mflex-container digi-ex-cont">
                <div>
                  <img alt="" src={plat11} className="platimgnew" />

                  <p className="platparagraph">Angular</p>
                </div>
                <div>
                  <img alt="" src={plat12} className="platimgnew" />
                  <p className="platparagraph">Javascript</p>
                </div>
              </div>

              <Collapse in={width < breakpoint ? openExp === "second" : true}>
                <div id="second">
                  <div class="mflex-container">
                    <div>
                      <img alt="" src={plat13} className="platimgnew" />

                      <p className="platparagraph">ReactJS</p>
                    </div>
                    <div>
                      <img alt="" src={plat14} className="xcodeimg" />
                      <p className="platparagraph">VueJS</p>
                    </div>
                  </div>
                  <div class="mflex-container">
                    <div>
                      <img alt="" src={plat15} className="platimgnew" />

                      <p className="platparagraph">Typescript</p>
                    </div>
                    <div>
                      <img alt="" src={plat16} className="xcodeimg" />
                      <p className="platparagraph">MEAN</p>
                    </div>
                  </div>
                </div>
              </Collapse>
              <button className="d-xl-none d-lg-none d-md-none collapse-btn-services text-center mr-auto ml-auto pt-2">
                {openExp === "second" ? (
                  <FontAwesomeIcon
                    icon="chevron-up"
                    onClick={() => setOpenExp(false)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon="chevron-down"
                    onClick={() => setOpenExp("second")}
                    aria-controls="second"
                    aria-expanded="second"
                  />
                )}
              </button>
            </div>
          </ScrollAnimation>
        </Col>

        {/* section 3 */}
        <Collapse
          in={width < breakpoint ? openWeb : true}
          className="collapse-div"
        >
          <div id="collapse-services-learning">
            <Col md={6} sm={6} xs={12} lg={6} xl={3}>
              <ScrollAnimation
                animateIn="fadeIn"
                duration={2}
                animateOnce={true}
              >
                <div class="numberCircle textcenter">
                  <img alt="" src={icon3} className="platimage" />
                </div>
                <div
                  className="card platcard digi-platforms"
                  style={{ height: "auto" }}
                >
                  <p className="devheading">
                    <span className="bold">
                      {" "}
                      Back-End <br /> Development
                    </span>
                    <AnimatedLine
            className="animateline"
            width={"200px"}
            margin={"10px auto"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>
                  </p>
                 
                  <div class="mflex-container digi-ex-cont">
                    <div>
                      <img alt="" src={plat17} className="platimgnew " />

                      <p className="platparagraph">Amazon Web Services</p>
                    </div>
                    <div>
                      <img alt="" src={plat18} className="platimgnew " />
                      <p className="platparagraph">Hadoop</p>
                    </div>
                  </div>
                  <div class="mflex-container digi-ex-cont">
                    <div>
                      <img alt="" src={plat19} className="platimgnew" />

                      <p className="platparagraph">NodeJS</p>
                    </div>
                    <div>
                      <img alt="" src={plat20} className="platimgnew" />
                      <p className="platparagraph">Python</p>
                    </div>
                  </div>

                  <Collapse
                    in={width < breakpoint ? openExp === "third" : true}
                  >
                    <div id="third">
                      <div class="mflex-container">
                        <div>
                          <img alt="" src={plat21} className="platimgnew" />

                          <p className="platparagraph">Java</p>
                        </div>
                        <div>
                          <img alt="" src={plat22} className="xcodeimg" />
                          <p className="platparagraph">Mysql</p>
                        </div>
                      </div>
                      <div class="mflex-container">
                        <div>
                          <img alt="" src={plat23} className="platimgnew" />

                          <p className="platparagraph">PHP</p>
                        </div>
                        <div>
                          <img alt="" src={plat24} className="xcodeimg" />
                          <p className="platparagraph">DevOps</p>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <button className="d-xl-none d-lg-none d-md-none collapse-btn-services text-center mr-auto ml-auto pt-2">
                    {openExp === "third" ? (
                      <FontAwesomeIcon
                        icon="chevron-up"
                        onClick={() => setOpenExp(false)}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon="chevron-down"
                        onClick={() => setOpenExp("third")}
                        aria-controls="third"
                        aria-expanded="third"
                      />
                    )}
                  </button>
                </div>
              </ScrollAnimation>
            </Col>

            {/* section 4 */}
            <Col md={6} sm={6} xs={12} lg={6} xl={3}>
              <ScrollAnimation
                animateIn="fadeIn"
                duration={2}
                animateOnce={true}
              >
                <div class="numberCircle textcenter">
                  <img alt="" src={icon4} className="platimage" />
                </div>
                <div
                  className="card platcard digi-platforms"
                  style={{ height: "auto" }}
                >
                  <p className="devheading">
                    <span className="bold">
                      {" "}
                      Content Management <br /> System

                    </span>
                    <AnimatedLine
            className="animateline"
            width={"200px"}
            margin={"10px auto"}
          >
            <ScrollAnimation
              animateIn="fadeInLeft"
              duration={2}
              animateOnce={true}
              className="no-animation"
            >
              <div className="line"></div>
            </ScrollAnimation>
          </AnimatedLine>
                  </p>
                 
                  <div class="mflex-container digi-ex-cont">
                    <div>
                      <img alt="" src={plat25} className="platimgnew " />

                      <p className="platparagraph">Wordpress</p>
                    </div>
                    <div>
                      <img alt="" src={plat26} className="platimgnew " />
                      <p className="platparagraph">Drupal</p>
                    </div>
                  </div>
                  <div class="mflex-container digi-ex-cont">
                    <div>
                      <img alt="" src={plat27} className="platimgnew" />

                      <p className="platparagraph">Sharepoint</p>
                    </div>
                    <div>
                      <img alt="" src={plat28} className="platimgnew" />
                      <p className="platparagraph">Magento</p>
                    </div>
                  </div>

                  <Collapse
                    in={width < breakpoint ? openExp === "fourth" : true}
                  >
                    <div id="fourth">
                      <div class="mflex-container">
                        <div>
                          <img alt="" src={plat29} className="platimgnew" />

                          <p className="platparagraph">Shopify</p>
                        </div>
                        <div>
                          <img alt="" src={plat30} className="xcodeimg" />
                          <p className="platparagraph">WP-Commerce</p>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <button className="d-xl-none d-lg-none d-md-none collapse-btn-services text-center mr-auto ml-auto pt-2">
                    {openExp === "fourth" ? (
                      <FontAwesomeIcon
                        icon="chevron-up"
                        onClick={() => setOpenExp(false)}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon="chevron-down"
                        onClick={() => setOpenExp("fourth")}
                        aria-controls="fourth"
                        aria-expanded="fourth"
                      />
                    )}
                  </button>
                </div>
              </ScrollAnimation>
            </Col>
          </div>
        </Collapse>
        <button
          onClick={() => setOpenWeb(!openWeb)}
          aria-controls="collapse-services-learning"
          aria-expanded={openWeb}
          className="d-xl-none d-lg-none d-md-none collapse-btn text-center mr-auto ml-auto pt-2"
        >
          {openWeb ? (
            ""
          ) : (
            <>
              <span className="expand readmore">
                Expand More <FontAwesomeIcon icon="angle-double-right" />
              </span>
            </>
          )}
        </button>
      </Row>
    </Container>

    //

    // circle menu
  );
};
